import React, { useEffect, useState } from "react";
import AuthService from "../../../../api/AuthService";
// eslint-disable-next-line import/default
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../context/AlertContext";
import TravelallowancesPage from "../../../../entities/DashboardPage/HRModule/TravelallowancesPage";

const Travelallowances = () => {
  const { showAlert } = useAlert();
  const [permission, setPermission] = useState(null);
  const role = localStorage.getItem("role");
  const employeeId = localStorage.getItem("employeeId");
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(1);

  const [leaveType, setLeaveType] = useState([]);
  const [employeeData, setEmployeeData] = useState();
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [sort, setSort] = useState("");
  const [empData, setempData] = useState([]);
  const [depData, setDepData] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);
  const [singleTravelClaimData, setSingleTravelClaimData] = useState([]);

  // Fetch permissions from API only for Employee role
  const fetchPermissions = async () => {
    if ((role === "Employee" || role === "employee") && employeeId) {
      try {
        const permissionResult = await AuthService.getEmployeePermission(employeeId);
        if (permissionResult?.success && permissionResult?.data) {
          const permissions = permissionResult?.data;
          setPermission(permissions);
        }
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    } else {
      // For Admin/SuperAdmin, use localStorage
      const permissionObj = localStorage.getItem("permission");
      setPermission(permissionObj ? JSON.parse(permissionObj) : null);
    }
  };

  useEffect(() => {
    fetchPermissions();
    
    // Listen for permission updates
    const handlePermissionUpdate = () => {
      fetchPermissions();
    };
    
    window.addEventListener("permissionUpdated", handlePermissionUpdate);
    return () => {
      window.removeEventListener("permissionUpdated", handlePermissionUpdate);
    };
  }, []);

  useEffect(() => {
    if (permission !== null || role !== "Employee" && role !== "employee") {
      getLeaveManagementLists("", "", page);
      getLeaveType();
    }
  }, [page, permission])

  useEffect(() => {
    getAllDepartmentList();
    getDepartment();
  }, [])

  const getLeaveManagementLists = async (text, sort, page) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getTravelAllowances(text, sort, page);
      if (result?.success) {
        let travelAllowances = result?.data?.travelAllowances || [];
        
        // Filter data based on permissions for Employee role
        if ((role === "Employee" || role === "employee") && employeeId && permission) {
          const hasViewPermission = permission?.travelAllowance?.isView === true;
          const hasEditPermission = permission?.travelAllowance?.isEdit === true;
          
          // If employee has edit permission, show all travel allowances (like admin)
          if (hasEditPermission) {
            setTotal(result?.data?.total);
          } else if (hasViewPermission) {
            // If only view permission, show only own data
            travelAllowances = travelAllowances.filter((ta) => ta?.employee?._id === employeeId || ta?.employee?.userId === employeeId);
            setTotal(travelAllowances.length);
          } else {
            // No view permission, show nothing
            travelAllowances = [];
            setTotal(0);
          }
        } else {
          setTotal(result?.data?.total);
        }
        
        setData(travelAllowances);
        setFilteredData(travelAllowances);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const SearchEmployee = async (text) => {
    setLoading(true);
    try {
      const result = await AuthService.getEmployeeList(text);
      if (result?.success) {
        setEmployeeData(result?.data?.employees);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const getLeaveType = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAccountLeaveType();
      if (result?.success) {
        setLeaveType(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleLeaveApply = async (payload) => {
    setLoading(true);

    try {
      const result = await AuthService.handleApplyTravelAllowances(payload);
      if (result?.success) {
        showAlert(result?.message, "success");
        setTimeout(() => setOpen(false), 1500);
        getLeaveManagementLists()
        setLoading(false);
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
    }
  }
  const handleFilter = (text) => {
    setSearchText(text);
    getLeaveManagementLists(text, sort);
  };

  const handleSort = (sortOption) => {
    setSort(sortOption);
    getLeaveManagementLists(searchText, sortOption);
  };

  const getAllDepartmentList = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAllDepartmentList();
      if (result?.success) {
        setempData(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  
  const DepartmentPayroll = async (department) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handlePayrollDepartmemt(department);
      if (result?.success) {
        setDepData(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getDepartment = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getDepartment();
      if (result?.success) {
        setDepartmentData(result?.data?.position);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const DeleteCommission = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.TravelAllowancesDelete(id);
      if (result?.success) {
        showAlert(result?.message, "success");
        LoaderHelper.loaderStatus(false);
        getLeaveManagementLists("", "", page);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getApprovedTravelAllowance = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getApprovedTravelAllowance();
      if (result?.success) {
        showAlert(result?.message, "success");
        LoaderHelper.loaderStatus(false);
        getLeaveManagementLists();
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error")
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const updateTravelAllowances = async (id, payload) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.TravelAllowancesUpdate(id, payload);
      if (result?.success) {
        showAlert(result?.message, "success");
        LoaderHelper.loaderStatus(false);
        getLeaveManagementLists();
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error")
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleRequest = async (id, status) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleTravelAllowancesRequest(id, status);
      if (result?.success) {
        LoaderHelper.loaderStatus(false);
        getLeaveManagementLists();
        setTimeout(() => setOpen(false), 1500);
        showAlert(result?.message, "success");
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  }

  const getSingleTravelClaimData = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getSingleTravelClaimData(id);
      setSingleTravelClaimData(result?.data);
      if (result?.success) {
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  }

  const getTravelAllowanceDefaults = async (params) => {
    try {
      const result = await AuthService.getTravelAllowanceDefaults(params);
      if (result?.success === false) {
        showAlert(result?.message || "Unable to fetch travel defaults.", "error");
        return null;
      }
      return result?.data || null;
    } catch (error) {
      showAlert("Unable to fetch travel defaults.", "error");
      return null;
    }
  };

  return (
    <TravelallowancesPage
      role={role}
      handleRequest={handleRequest}
      getApprovedTravelAllowance={getApprovedTravelAllowance}
      permission={permission}
      page={page}
      total={total}
      setPage={setPage}
      handleEmployee={SearchEmployee}
      loading={loading}
      employeeData={employeeData}
      data={filteredData.length > 0 ? filteredData : data}
      open={open}
      setOpen={setOpen}
      handleLeaveApply={handleLeaveApply}
      handleFilter={handleFilter}
      handleSort={handleSort}
      getLeaveManagementLists={getLeaveManagementLists}
      empData={empData}
      depData={depData}
      DepartmentPayroll={DepartmentPayroll}
      departmentData={departmentData}
      DeleteCommission={DeleteCommission}
      updateTravelAllowances={updateTravelAllowances}
      singleTravelClaimData={singleTravelClaimData}
      getSingleTravelClaimData={getSingleTravelClaimData}
      fetchTravelAllowanceDefaults={getTravelAllowanceDefaults}
    />
  )

}

export default Travelallowances;
